import axios from '../config/axios';
import { CF_CASH_CDT_ITEMS, CF_CASH_FLOW, CF_CASH_FLOW_GET_USER_FILTERS, CF_CASH_FLOW_RESET, CF_CASH_FLOW_SAVE_USER_FILTERS, CF_CASH_PCG_ITEMS, CF_CASH_PCG_ITEMS_RESET, CF_CASH_RESOURCE_ITEMS, CF_CASH_RUBRO_ITEMS, CF_CASH_STRUCTURE, CF_COINS, CF_COINS_LOADING, CF_COMPANIES, CF_COMPANIES_LOADING, CF_PROJECTS_BY_COMPANY, CF_PROJECTS_BY_COMPANY_RESET } from '../constants';
let company = JSON.parse(localStorage.getItem("company-s10"));
let user = JSON.parse(localStorage.getItem("user-s10"));

const signalRequest = async ( requestId, objectName ) => {
	const body = {
		HasOutputParam: false,
		ObjectName: objectName,
		RequestId: requestId,
		SignalRConnectionID: await localStorage.getItem("connectionId"),
		SecurityUserId: user.IdUser ? user.IdUser : user.UserId,
	};
	const headers = {
		Token: company.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
	};
	
	await axios.post( 
		"",
		body,
		{
			headers: headers,
		}
	);
}

export const getCoinsRequest = () => {
	return async (dispatch, getState) => {
		const state = getState();
		const cashFlow = state.cashFlow;
		if (cashFlow.coinsLoading || cashFlow.coins.length) {
			return;
		}
		dispatch({ type: CF_COINS_LOADING });
		await signalRequest(
			CF_COINS,
			`dbo.S10_00_Moneda_Listar`
		);
	};
};

export const getCompaniesRequest = (startDate, endDate) => {
	const finalStartDate = startDate ? `'${startDate}'` : 'null';
	const finalEndDate = endDate ? `'${endDate}'` : 'null';

	return async (dispatch, getState) => {
		const state = getState();
		const cashFlow = state.cashFlow;
		if (cashFlow.companiesLoading || cashFlow.companies.length) {
			return;
		}
		dispatch({ type: CF_COMPANIES_LOADING });
		await signalRequest(
			CF_COMPANIES,
			`dbo.S10_10_Empresa_Listar ${finalStartDate},${finalEndDate}`,
		);
	};
};

export const getProjetsByCompanyRequest = async (companyId, startDate, endDate) =>{
	const finalStartDate = startDate ? `'${startDate}'` : 'null';
	const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		CF_PROJECTS_BY_COMPANY,
		`dbo.S10_00_Proyecto_ListarPorEmpresa '${companyId}', ${finalStartDate},${finalEndDate}`,
	);
}

export const getProjetsByCompanyByDimensionRequest = async (companyId, startDate, endDate, dimension) =>{
	const finalStartDate = startDate ? `'${startDate}'` : 'null';
	const finalEndDate = endDate ? `'${endDate}'` : 'null';
	await signalRequest(
		CF_PROJECTS_BY_COMPANY,
		`dbo.S10_00_Dimension_ListarPorEmpresa '${companyId}',${finalStartDate},${finalEndDate},'${dimension}'`,
	);
}

export const resetProjetsByCompanyRequest = () => {	
	return ({
		type: CF_PROJECTS_BY_COMPANY_RESET,
	})
}

/*
@CodEmpresa puede ser nulo o blanco
@CodProyecto puede ser nulo o blanco
@TipoPeriodo 0=mensual, 1=semanal y 2=Año
*/
export const cashFlowGeneral = async (startDate, endDate, companyCode = '', projectcode = '', period='0') =>{
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneral_Listar '${startDate}','${endDate}','${companyCode}','${projectcode}','${period}'`,
	);
}

export const cashFlowGeneralByDimension = async (startDate, endDate, companyCode, period, mode, dimensionCode) => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralDimension_Listar '${startDate}','${endDate}','${companyCode}','${period}','${mode}','${dimensionCode}'`,
	);
}

export const resetCashFlowGeneral = () => {	
	return ({
		type: CF_CASH_FLOW_RESET,
	})
}

export const cashFlowStructure = async () => {
	await signalRequest(
		CF_CASH_STRUCTURE,
		`dbo.S10_06_PartidaControlGeneral_ListarEstructura`,
	);
}

export const resetCashFlowPCGItemsReset = () => {
	return ({
		type: CF_CASH_PCG_ITEMS_RESET,
	})
}

export const cashFlowItemsResumeByProject = async (endDate, pcgLevel, companyCode = '', projectcode = '') => {
	await signalRequest(
		CF_CASH_PCG_ITEMS,
		`dbo.S10_00_FujoCajaPCG_ListarSaldo '${endDate}','${companyCode}','${projectcode}','${pcgLevel}'`,
	);
}

export const cashFlowItemsResumeByDimension = async (endDate, pcgLevel, dimension, companyCode = '', dimensionCode = '') => {
	await signalRequest(
		CF_CASH_PCG_ITEMS,
		`dbo.S10_00_FujoCajaPCG_Dimension_ListarSaldo '${endDate}','${companyCode}','${pcgLevel}','${dimension}','${dimensionCode}'`,
	);
}

export const cashFlowPCGResume = async (startDate, endDate, companyCode, projectcode, period, pcgLevel, pcgCode = '') => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralPCG_Listar '${startDate}','${endDate}','${companyCode}','${projectcode}','${period}','${pcgLevel}','${pcgCode}'`,
	);
}

export const cashFlowPCGDimensionResume = async (startDate, endDate, companyCode, period, pcgLevel, pcgCode, dimension, dimensionCode) => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralPCG_Dimension_Listar '${startDate}','${endDate}','${companyCode}','${period}','${pcgLevel}','${pcgCode}','${dimension}','${dimensionCode}'`,
	);
}

export const cashFlowRubroItemsResumeByProject = async (endDate, companyCode = '', projectcode = '') => {
	await signalRequest(
		CF_CASH_RUBRO_ITEMS,
		`dbo.S10_00_FujoCajaRubro_ListarSaldo '${endDate}','${companyCode}','${projectcode}'`,
	);
}

export const cashFlowRubroItemsResumeByDimension = async (endDate, dimension, companyCode = '', dimensionCode = '') => {
	await signalRequest(
		CF_CASH_RUBRO_ITEMS,
		`dbo.S10_00_FujoCajaRubro_Dimension_ListarSaldo '${endDate}','${companyCode}','${dimension}','${dimensionCode}'`,
	);
}

export const cashFlowRubroResume = async (startDate, endDate, companyCode, projectcode, period, codRubro) => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralRubro_Listar '${startDate}','${endDate}','${companyCode}','${projectcode}','${period}','${codRubro}'`,
	);
}

export const cashFlowRubroDimensionResume = async (startDate, endDate, companyCode, period, codRubro, dimension, dimensionCode) => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralRubro_Dimension_Listar '${startDate}','${endDate}','${companyCode}','${period}','${codRubro}','${dimension}','${dimensionCode}'`,
	);
}

export const cashFlowResourceItemsResumeByProject = async (startDate, endDate, companyCode = '', projectcode = '', resourceLevel='1') => {
	await signalRequest(
		CF_CASH_RESOURCE_ITEMS,
		`dbo.S10_00_FujoCajaRecurso_ListarSaldo '${endDate}','${companyCode}','${projectcode}',${resourceLevel}`,
	);
}

export const cashFlowResourceItemsResumeByDimension = async (startDate, endDate, dimension, companyCode = '', dimensionCode = '', resourceLevel='1') => {
	await signalRequest(
		CF_CASH_RESOURCE_ITEMS,
		`dbo.S10_00_FujoCajaRecurso_Dimension_ListarSaldo '${endDate}','${companyCode}',${resourceLevel},'${dimension}','${dimensionCode}'`,
	);
}

export const cashFlowResourceResume = async (startDate, endDate, companyCode, projectcode, period, codResource, resourceLevel='1') => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralRecurso_Listar '${startDate}','${endDate}','${companyCode}','${projectcode}','${period}','${resourceLevel}','${codResource}'`,
	);
}

export const cashFlowResourceDimensionResume = async (startDate, endDate, companyCode, period, codResource, dimension, dimensionCode, resourceLevel='1') => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralRecurso_Dimension_Listar '${startDate}','${endDate}','${companyCode}','${period}','${resourceLevel}','${codResource}','${dimension}','${dimensionCode}'`,
	);
}

export const cashFlowCDTItemsResumeByProject = async (endDate, companyCode = '', projectcode = '') => {
	await signalRequest(
		CF_CASH_CDT_ITEMS,
		`dbo.S10_00_FujoCajaCTD_ListarSaldo '${endDate}','${companyCode}','${projectcode}'`,
	);
}

export const cashFlowCDTItemsResumeByDimension = async (endDate, dimension, companyCode = '', dimensionCode = '') => {
	await signalRequest(
		CF_CASH_CDT_ITEMS,
		`dbo.S10_00_FujoCajaCTD_Dimension_ListarSaldo '${endDate}','${companyCode}','${dimension}','${dimensionCode}'`,
	);
}

export const cashFlowCDTResume = async (startDate, endDate, companyCode, projectcode, period, codCDT) => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralCTD_Listar '${startDate}','${endDate}','${companyCode}','${projectcode}','${period}','${codCDT}'`,
	);
}

export const cashFlowCDTDimensionResume = async (startDate, endDate, companyCode, period, codCDT, dimension, dimensionCode) => {
	await signalRequest(
		CF_CASH_FLOW,
		`dbo.S10_00_FujoCajaGeneralCTD_Dimension_Listar '${startDate}','${endDate}','${companyCode}','${period}','${codCDT}','${dimension}','${dimensionCode}'`,
	);
}


export const getCashFlowPreselectedFilters = () => {
	return async (dispatch, getState) => {
		const state = getState();
		const {User} = state.auth;
		await signalRequest(
			CF_CASH_FLOW_GET_USER_FILTERS,
			`dbo.S10_00_BI_FiltroTablero_Listar '${User.UserName}'`,
		);
	};
};

/*
CREATE PROC [dbo].[S10_00_BI_FiltroTablero_Grabar] 
    @Email		varchar(128),
    @Moneda		varchar(24) = NULL,
    @CodEmpresa	varchar(8) = NULL,
    @Modo		varchar(24) = NULL,
    @ValorModo	varchar(24) = NULL,
    @Escala		tinyint = NULL,
    @Del		smalldatetime = NULL,
    @Al			smalldatetime = NULL
*/
export const setCashFlowPreselectedFilters = (coinCode, companyCode, mode, modeValue, scale, startDate, endDate) => {
	return async (dispatch, getState) => {
		const state = getState();
		const {User} = state.auth;
		const finalCoinCode = coinCode ? `'${coinCode}'` : 'null';
		const finalCompanyCode = companyCode ? `'${companyCode}'` : 'null';
		const finalMode = mode ? `'${mode}'` : 'null';
		const finalModeValue = modeValue ? `'${modeValue}'` : 'null';
		const finalScale = scale ? `'${scale}'` : 'null';
		const finalStartDate = startDate ? `'${startDate}'` : 'null';
		const finalEndDate = endDate ? `'${endDate}'` : 'null';
		await signalRequest(
			`${CF_CASH_FLOW_SAVE_USER_FILTERS}_BD`,
			`dbo.S10_00_BI_FiltroTablero_Grabar '${User.UserName}',${finalCoinCode},${finalCompanyCode},${finalMode},${finalModeValue},${finalScale},${finalStartDate},${finalEndDate}`,
		);
		dispatch({ 
			type: CF_CASH_FLOW_SAVE_USER_FILTERS,
			payload: {
				Modo: mode,
				Moneda: coinCode,
				Del: startDate,
				Al: endDate,
			}
		});
	};
};